import { AfterViewInit, Component, ViewChild, ViewContainerRef } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';

export interface ICellMatDatePickerParams extends ICellEditorParams {
  getMaxDate?: (t: any) => Date;
  getMinDate?: (t: any) => Date;
  dateFilter?: (t: any, d: Date) => boolean;
}

/** Adapts MatDatePicker to work as an ag-grid cell editor */
@Component({
  selector: 'date-cell',
  template: `
    <mat-form-field>
      <input
        matInput
        #dateInput
        [matDatepicker]="picker"
        [matDatepickerFilter]="dateFilter"
        [min]="minDate"
        [max]="maxDate"
        [name]="name"
        [(ngModel)]="selectedDate"
        [ngClass]="{ 'text-red-400': !isValid() }" />
      <mat-datepicker-toggle style="margin-left: -8px;" matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  `,
})
export class CellMatDatePickerComponent implements ICellEditorAngularComp, AfterViewInit {
  @ViewChild('dateInput', { read: ViewContainerRef }) dateInput;
  selectedDate: Date = null;
  originalDate: Date = null;
  minDate: Date = null;
  maxDate: Date = null;
  name: string;
  private params: ICellMatDatePickerParams;

  agInit(params: any): void {
    this.params = params;
    this.name = 'datePicker-' + params.column.colId;
    this.minDate = params.getMinDate && params.getMinDate(params.data);
    if (!this.minDate) {
      this.minDate = new Date(1900, 0, 1);
    }
    this.maxDate = params.getMaxDate && params.getMaxDate(params.data);
    if (!this.maxDate) {
      this.maxDate = new Date(new Date().getFullYear() + 100, 0, 1);
    }
    this.dateFilter = this.dateFilter.bind(this);
  }

  /** Return true if date is allowed, false otherwise */
  dateFilter(d: Date) {
    if (!d || !d.getTime) { return false; }
    const time = d.getTime();
    if (!(time >= this.minDate.getTime() && time <= this.maxDate.getTime())) {
      return false;
    }
    if (this.params.dateFilter) {
      return this.params.dateFilter(this.params.data, d);
    }
    return true;
  }

  isValid(): boolean {
    if (!this.selectedDate) {
      return true;
    }
    if (!this.selectedDate.getTime) {
      return false;
    }
    return this.dateFilter(this.selectedDate);
  }

  getValue(): Date {
    if (!this.isValid()) {
      return this.originalDate;
    }
    if (this.selectedDate) {
      this.selectedDate.setHours(0, 0, 0, 0);
    }
    return this.selectedDate;
  }

  afterGuiAttached(): void {
    if (!this.params.value) {
      return;
    }
    this.selectedDate = this.params.value;
    this.originalDate = this.params.value;
  }

  ngAfterViewInit(): void {
    // put cursor in input when activated
    setTimeout(() => this.dateInput.element.nativeElement.focus(), 0);
  }
}
